import { getApps as P, initializeApp as ae } from "firebase/app";
import { getFirestore as se, doc as V, collection as G, addDoc as ne, getDoc as x, setDoc as M, deleteDoc as ie, getDocs as $, onSnapshot as y, orderBy as H, query as re } from "firebase/firestore";
const h = "feature-flags", v = "feature-flags-archived", f = "feature-configs", p = "segments", b = "feature-conditions", D = "brave-ship-storage", L = "feature-management-service", ee = "feature-history-service", w = "global", j = `${D}-feat-cleanup-timestamp`, oe = 7 * 24 * 60 * 60 * 1e3, F = class F {
  constructor(e, t) {
    this.workspace = t;
    const a = P().length === 0 ? ae(e) : P()[0];
    this.db = se(a);
  }
  createDocReference(e, t, a, s = L) {
    return V(this.db, s, a, t, e);
  }
  createCollectionReference(e, t, a = L) {
    return G(this.db, a, t, e);
  }
  addDocToCollection(e, t) {
    return ne(e, t);
  }
  static getInstance(e, t) {
    return F.instance || (F.instance = new F(e, t)), F.instance.workspace = t, F.instance;
  }
  // Paths and Refs
  getCollectionPath(e, t = this.workspace) {
    return [L, t, e];
  }
  getDocRef(e, t, a = this.workspace) {
    return V(this.db, ...this.getCollectionPath(e, a), t);
  }
  getCollectionRef(e, t = this.workspace) {
    return G(this.db, ...this.getCollectionPath(e, t));
  }
  async create(e, t, a) {
    try {
      const s = this.getDocRef(e, t);
      await this.createWithRef(s, a), console.log(`[FirestoreDb] Created/Updated '${t}' in '${e}'`);
    } catch (s) {
      throw console.error(`[FirestoreDb] Failed to create '${t}' in '${e}':`, s), s;
    }
  }
  async createWithRef(e, t) {
    try {
      if (t.createdAt = (/* @__PURE__ */ new Date()).toISOString(), (await x(e)).exists())
        throw new Error("Document with same name already exists in the workspace.");
      await M(e, t);
    } catch (a) {
      throw a;
    }
  }
  async read(e, t) {
    try {
      return await this.getDocWithFallback(e, t);
    } catch (a) {
      throw console.error(`[FirestoreDb] Failed to read '${t}' from '${e}':`, a), a;
    }
  }
  async readAll(e) {
    try {
      return await this.getAllDocsWithFallback(e);
    } catch (t) {
      throw console.error(`[FirestoreDb] Failed to read all from '${e}':`, t), t;
    }
  }
  async update(e, t, a, s = !1) {
    try {
      a.updatedAt = (/* @__PURE__ */ new Date()).toISOString(), await M(this.getDocRef(e, t), a), console.log(`[FirestoreDb] Updated '${t}' in '${e}'`);
    } catch (n) {
      throw console.error(`[FirestoreDb] Failed to update '${t}' in '${e}':`, n), n;
    }
  }
  // Delete
  async delete(e, t) {
    try {
      await ie(this.getDocRef(e, t)), console.log(`[FirestoreDb] Deleted ' <${this.workspace}> ${t}' from '${e}'`);
    } catch (a) {
      throw console.error(`[FirestoreDb] Failed to delete '${t}' from '${e}':`, a), a;
    }
  }
  async getDocWithFallback(e, t) {
    const a = await x(this.getDocRef(e, t));
    if (a.exists()) return a.data();
    if (this.workspace !== w) {
      const s = await x(this.getDocRef(e, t, w));
      if (s.exists())
        return { ...s.data(), __global_data: !0 };
    }
    return null;
  }
  async getAllDocsWithFallback(e) {
    const t = {};
    return (await $(this.getCollectionRef(e))).forEach((s) => {
      t[s.id] = s.data();
    }), this.workspace !== w && (await $(this.getCollectionRef(e, w))).forEach((n) => {
      t[n.id] || (t[n.id] = { ...n.data(), __global_data: !0 });
    }), t;
  }
  listenToDoc(e, t, a, s) {
    const n = this.getDocRef(e, t);
    return y(
      n,
      (i) => {
        a(i.exists() ? i.data() : null);
      },
      (i) => {
        console.error(`[FirestoreDb] Failed to listen to doc '${t}' in '${e}':`, i), s == null || s(i);
      }
    );
  }
  listenToCollection(e, t, a) {
    const s = this.getCollectionRef(e);
    return y(
      s,
      (n) => {
        const i = {};
        n.forEach((c) => {
          i[c.id] = c.data();
        }), t(i);
      },
      (n) => {
        console.error(`[FirestoreDb] Failed to listen to collection '${e}':`, n), a == null || a(n);
      }
    );
  }
  listenToCollectionWithFallback(e, t, a) {
    return this.listenWithFallback(
      (s) => y(
        this.getCollectionRef(e),
        (n) => {
          const i = {};
          n.forEach((c) => {
            i[c.id] = c.data();
          }), s(i);
        },
        (n) => {
          console.error(`[FirestoreDb] Failed to listen to collection '${e}' (local):`, n), a == null || a(n);
        }
      ),
      (s) => y(
        this.getCollectionRef(e, w),
        (n) => {
          const i = {};
          n.forEach((c) => {
            i[c.id] = c.data();
          }), s(i);
        },
        (n) => {
          console.error(`[FirestoreDb] Failed to listen to collection '${e}' (global):`, n), a == null || a(n);
        }
      ),
      (s, n) => {
        const i = { ...n, ...s };
        for (const c in n)
          s && !s[c] && (i[c] = { ...n[c], __global_data: !0 });
        return i;
      },
      t,
      a
    );
  }
  listenToDocWithFallback(e, t, a, s) {
    return this.listenWithFallback(
      (n) => y(
        this.getDocRef(e, t),
        (i) => n(i.exists() ? i.data() : null),
        (i) => {
          console.error(`[FirestoreDb] Failed to listen to doc '${t}' (local):`, i), s == null || s(i);
        }
      ),
      (n) => y(
        this.getDocRef(e, t, w),
        (i) => n(i.exists() ? i.data() : null),
        (i) => {
          console.error(`[FirestoreDb] Failed to listen to doc '${t}' (global):`, i), s == null || s(i);
        }
      ),
      (n, i) => n || (i ? { ...i, __global_data: !0 } : null),
      a,
      s
    );
  }
  listenWithFallback(e, t, a, s, n) {
    let i, c;
    const l = () => {
      s(a(i, c));
    }, o = e((C) => {
      i = C, l();
    }), g = this.workspace !== w ? t((C) => {
      c = C, l();
    }) : () => {
    };
    return () => {
      o(), g();
    };
  }
};
F.instance = null;
let m = F;
class K {
  static async HashingBasedPercentageRollout(e, t, a) {
    if (t >= 100)
      return !0;
    if (typeof t != "number" || t <= 0 || !e || !a)
      return !1;
    try {
      const s = `${e}-${a}`, n = new TextEncoder().encode(s), i = await crypto.subtle.digest("SHA-256", n), l = Array.from(new Uint8Array(i)).map((C) => C.toString(16).padStart(2, "0")).join("");
      return (parseInt(l.substring(0, 8), 16) >>> 0) / 4294967295 < t / 100;
    } catch {
      return !1;
    }
  }
}
const R = (r, e) => r[e], B = (r) => new Date(r).getTime();
class te {
  toNumericValue(e) {
    return typeof e == "number" ? e : Number.isNaN(+e) ? [...e].reduce((t, a) => t + a.charCodeAt(0), 0) : +e;
  }
}
class T extends te {
  resolve(e) {
    return this.toNumericValue(e) % 2 === 0;
  }
}
class I extends te {
  resolve(e) {
    return this.toNumericValue(e) % 2 !== 0;
  }
}
class O {
  constructor(e, t) {
    this.attributeKey = e, this.contextValue = t;
  }
  resolve(e, t) {
    switch (t) {
      case ">":
        return this.contextValue > e;
      case "<":
        return this.contextValue < e;
      case "=":
        return this.contextValue == e;
      default:
        return !1;
    }
  }
}
class Y {
  constructor(e) {
    this.context = e, this.context = e;
  }
  async resolve(e, t, a) {
    const s = await e.get(t);
    return a === "in" ? !!(s != null && s.userInGroup(this.context)) : !(s != null && s.userInGroup(this.context));
  }
}
class q {
  async resolve(e, t, a) {
    const s = await e.get(t);
    if (!s) return !1;
    const n = await s.getIsEnabled();
    return a === "in" ? n : !n;
  }
}
class z {
  constructor(e) {
    this.evaluateFn = e;
  }
  async resolve(e, t, a) {
    const s = await e.get(t);
    if (!s) return !1;
    const { success: n } = await this.evaluateFn(s);
    return a === "in" ? n : !n;
  }
}
function ce(r) {
  if (!r)
    return !0;
  const e = /* @__PURE__ */ new Date(), t = new Date(r);
  return e >= t;
}
class J {
  constructor(e, t) {
    this.data = e, this.context = t;
  }
  updateUserContext(e) {
    this.context.userContext = {
      ...this.context.userContext,
      ...e
    };
  }
  updateDeviceContext(e) {
    this.context.deviceContext = {
      ...this.context.deviceContext,
      ...e
    };
  }
  getRaw() {
    return this.data;
  }
  getIsGlobal() {
    return this.getRaw().__global_data === !0;
  }
  async getRolloutEvaluation() {
    const e = this.data, t = this.context;
    if (!t || !e.rolloutStrategy)
      return {
        isEnabled: !0,
        reason: "No rollout strategy applied. Featured enabled for all users.",
        rolloutApplied: { type: null, value: 100 }
      };
    const { config: a, type: s } = e.rolloutStrategy;
    if (s === "percentage") {
      const n = a.percentage, i = await K.HashingBasedPercentageRollout(
        t.deviceContext.deviceID,
        n,
        t.localFeatureContext.featureName
      );
      return t.localFeatureContext.updateFeature({ enabled: i }), {
        isEnabled: i,
        reason: `Hashing-based percentage rollout (${n}%)`,
        rolloutApplied: { type: "percentage", value: n }
      };
    }
    if (s === "step") {
      const n = a.steps, i = /* @__PURE__ */ new Date(), l = [...n.map((o) => ({ ...o, date: new Date(o.date) })).filter((o) => !isNaN(o.date.getTime())).sort((o, g) => o.date.getTime() - g.date.getTime())].reverse().find((o) => o.date <= i);
      if (l) {
        const o = await K.HashingBasedPercentageRollout(
          t.deviceContext.deviceID,
          l.percentage,
          t.localFeatureContext.featureName
        );
        return t.localFeatureContext.updateFeature({ enabled: o }), {
          isEnabled: o,
          reason: `Step rollout (${l.percentage}%)`,
          rolloutApplied: {
            type: "step",
            value: l.percentage,
            matchedStep: {
              date: l.date.toISOString(),
              percentage: l.percentage
            }
          }
        };
      }
      return {
        isEnabled: !1,
        reason: "No step matched current date",
        rolloutApplied: { type: "step", value: 0 }
      };
    }
    return {
      isEnabled: !0,
      reason: "Unsupported rollout type. Fallback to default true.",
      rolloutApplied: { type: null, value: 100 }
    };
  }
  getIsDeviceLevelEnabled() {
    const e = this.context.localFeatureContext.retrieveFeature();
    return !e || e.enabled === void 0 ? null : e.enabled === !0;
  }
  async getIsEnabled() {
    return (await this.evaluateWithDetails()).isEnabled;
  }
  getIsReleaseDatePassed() {
    return ce(this.data.releaseDate);
  }
  async evalateConditions() {
    return !this.data.condition || !this.context ? {
      success: !0
    } : await this.evaluateConditionWithDetails(this.data.condition);
  }
  async evaluateConditionWithDetails(e) {
    var c, l;
    const t = {
      "device.registeredAt": this.context.deviceContext.deviceRegisteredAt,
      "feature.releaseDate": this.data.releaseDate,
      "device.id": this.context.deviceContext.deviceID,
      "user.id": (c = this.context.userContext) == null ? void 0 : c.userId,
      userAttributes: ((l = this.context.userContext) == null ? void 0 : l.customAttributes) || {},
      segmentContext: this.context.segmentContext,
      featureContext: this.context.featureContext,
      conditionContext: this.context.conditionContext
    }, a = (o) => {
      switch (o) {
        case "feature.releaseDate":
          return B(R(t, "feature.releaseDate"));
        case "device.registeredAt": {
          const g = R(t, "device.registeredAt"), C = +g;
          return Number.isNaN(C) ? B(g) : C;
        }
        case "even":
          return new T();
        case "odd":
          return new I();
        case "segment":
          return new Y(this.context);
        case "featureFlag":
          return new q();
        case "condition":
          return new z(this.evaluateConditionWithDetails.bind(this));
        default: {
          const g = R(t, o);
          return typeof o == "string" && o.startsWith("user.attributes.") ? new O(o.slice(16), g) : g ?? o;
        }
      }
    };
    if ("allOf" in e) {
      for (const o of e.allOf) {
        const g = await this.evaluateConditionWithDetails(o);
        if (!g.success)
          return {
            success: !1,
            failedCondition: g.failedCondition || o
          };
      }
      return { success: !0, passedConditions: e.allOf };
    }
    if ("anyOf" in e) {
      for (const o of e.anyOf)
        if ((await this.evaluateConditionWithDetails(o)).success)
          return { success: !0, passedConditions: [o] };
      return {
        success: !1,
        failedCondition: e.anyOf[0]
      };
    }
    const s = a(e.field), n = a(e.value);
    let i = !1;
    if (s instanceof Y)
      i = t.segmentContext ? await s.resolve(t.segmentContext, n, e.operator) : !1;
    else if (s instanceof q)
      i = t.featureContext ? await s.resolve(t.featureContext, n, e.operator) : !1;
    else if (s instanceof z)
      i = t.featureContext ? await s.resolve(t.conditionContext, n, e.operator) : !1;
    else if (n instanceof T || n instanceof I || n instanceof O)
      i = n.resolve(s, e.operator);
    else if (s instanceof T || s instanceof I || s instanceof O)
      i = s.resolve(n, e.operator);
    else
      switch (e.operator) {
        case ">":
          i = s > n;
          break;
        case "<":
          i = s < n;
          break;
        case "=":
          i = s == n;
          break;
        default:
          i = !1;
      }
    return i ? { success: !0, passedConditions: [e] } : { success: !1, failedCondition: e };
  }
  async evaluateWithDetails() {
    const e = this.data.enabled, t = this.getIsReleaseDatePassed();
    if (!e)
      return {
        isEnabled: !1,
        reason: "Feature flag is not enabled",
        isReleaseDatePassed: t,
        conditionMatched: !1
      };
    const a = await this.evalateConditions();
    if (!t)
      return {
        isEnabled: !1,
        reason: "Release date not passed",
        isReleaseDatePassed: t,
        conditionMatched: a.success
      };
    if (!a.success)
      return {
        isEnabled: !1,
        reason: `Condition not matched: ${JSON.stringify(a.failedCondition)}`,
        conditionMatched: a.success,
        isReleaseDatePassed: t
      };
    const s = this.getIsDeviceLevelEnabled();
    if (s !== null && s === !0)
      return {
        isEnabled: s,
        reason: "Feature enabled due to device-level override. If this is unintended, try clearing local storage or enabling local cache cleanup in the feature playground.",
        conditionMatched: a.success,
        isReleaseDatePassed: t,
        deviceLevelOverride: !0
      };
    const n = await this.getRolloutEvaluation();
    return {
      isEnabled: n.isEnabled,
      reason: n.reason,
      conditionMatched: a.success,
      isReleaseDatePassed: t,
      rolloutApplied: n.rolloutApplied
    };
  }
  async evaluateInPlayground(e) {
    return e.cleanupLocalFeatureCache && this.context.localFeatureContext.removeFeature(), await this.evaluateWithDetails();
  }
}
let E;
const le = new Uint8Array(16);
function ue() {
  if (!E && (E = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !E))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return E(le);
}
const d = [];
for (let r = 0; r < 256; ++r)
  d.push((r + 256).toString(16).slice(1));
function de(r, e = 0) {
  return d[r[e + 0]] + d[r[e + 1]] + d[r[e + 2]] + d[r[e + 3]] + "-" + d[r[e + 4]] + d[r[e + 5]] + "-" + d[r[e + 6]] + d[r[e + 7]] + "-" + d[r[e + 8]] + d[r[e + 9]] + "-" + d[r[e + 10]] + d[r[e + 11]] + d[r[e + 12]] + d[r[e + 13]] + d[r[e + 14]] + d[r[e + 15]];
}
const he = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), N = {
  randomUUID: he
};
function ge(r, e, t) {
  if (N.randomUUID && !e && !r)
    return N.randomUUID();
  r = r || {};
  const a = r.random || (r.rng || ue)();
  return a[6] = a[6] & 15 | 64, a[8] = a[8] & 63 | 128, de(a);
}
const fe = () => ge();
function Q(r, e = "local", t) {
  const a = e === "local" ? localStorage : sessionStorage;
  let s = a.getItem(r);
  if (!s) {
    switch (t) {
      case "time":
        s = Date.now().toString();
        break;
      case "random":
        s = Math.random().toString();
        break;
      case "uuid":
      default:
        s = fe();
        break;
    }
    a.setItem(r, s);
  }
  return s;
}
function pe() {
  if (typeof window > "u")
    return "android";
  if (typeof (window == null ? void 0 : window.ReactNativeWebView) < "u")
    return "native-web-view";
  const r = navigator.userAgent.toLowerCase();
  return r.includes("iphone") ? "iphone-web" : r.includes("android") ? "android-web" : "web";
}
class A {
  constructor(e, t) {
    this.featureName = e, this.isGlobal = t;
  }
  static getOrSetDeviceContext(e, t) {
    return {
      deviceID: Q(`${t}-brave-ship-device-id`, "local", "uuid"),
      deviceRegisteredAt: Q(`${t}-brave-ship-registered-at`, "local", "time"),
      devicePlatform: pe(),
      environment: e
    };
  }
  updateFeature(e) {
    const t = this.retrieveFeature(), a = JSON.stringify({
      ...t || {},
      ...e
    }), s = this.generateStorageKey();
    return typeof window < "u" && localStorage.setItem(s, a), a;
  }
  retrieveFeature() {
    const e = this.generateStorageKey(), t = typeof window > "u" ? null : localStorage.getItem(e);
    return t ? JSON.parse(t) : null;
  }
  generateStorageKey() {
    const e = this.isGlobal ? "-global" : "";
    return `${D}-${this.featureName}${e}`;
  }
  removeFeature() {
    const e = this.generateStorageKey();
    localStorage.removeItem(e);
  }
  static async cleanupStaleFeatures(e) {
    if (typeof window > "u") return;
    const t = parseInt(localStorage.getItem(j) || "0", 10), a = Date.now();
    if (a - t < oe) return;
    const s = /* @__PURE__ */ new Set();
    e.forEach((n) => {
      s.add(`${D}-${n}`), s.add(`${D}-${n}-global`);
    });
    for (let n = 0; n < localStorage.length; n++) {
      const i = localStorage.key(n);
      i != null && i.startsWith(D) && !s.has(i) && localStorage.removeItem(i);
    }
    localStorage.setItem(j, a.toString());
  }
}
class be {
  constructor(e, t) {
    this.segmentName = e, this.segmentData = t;
  }
  getSegmentData() {
    return this.segmentData;
  }
  getIsGlobal() {
    return this.getSegmentData().__global_data === !0;
  }
  userInGroup(e) {
    var s, n, i, c, l;
    const t = this.segmentData.criteria.list.map(
      (o) => typeof o == "string" ? o.toLowerCase() : o
    ), a = (o) => o ? t.includes(o.toLowerCase()) : !1;
    switch (this.segmentData.type) {
      case "user.id":
        return a((s = e.userContext) == null ? void 0 : s.userId);
      case "device.platform":
        return a((n = e.deviceContext) == null ? void 0 : n.devicePlatform);
      case "device.environment":
        return a((i = e.deviceContext) == null ? void 0 : i.environment);
      case "geo.state":
        return a((l = (c = e.userContext) == null ? void 0 : c.userLocation) == null ? void 0 : l.state);
      default:
        return !1;
    }
  }
}
class Ce {
  constructor(e, t) {
    this.config = t, this.featureName = e;
  }
  getIsGlobal() {
    return this.getConfigs().__global_data === !0;
  }
  getConfigs() {
    return this.config;
  }
  getIsInMaintenance(e = "*", t = "auto") {
    var s, n;
    if (t === "none" || !((n = (s = this.config) == null ? void 0 : s.plannedReleases) != null && n.length))
      return !1;
    const a = this.getActiveRelease();
    if (!a || e !== "*" && (!a.scopes || !a.scopes.includes(e)))
      return !1;
    if (t === "always") {
      const i = a.downtimeStartAt ? new Date(a.downtimeStartAt).getTime() : null;
      return i !== null && i <= Date.now();
    }
    return !0;
  }
  getActiveRelease() {
    var t;
    const e = Date.now();
    return ((t = this.config.plannedReleases) == null ? void 0 : t.find((a) => {
      const s = a.downtimeStartAt ? new Date(a.downtimeStartAt).getTime() : null, n = a.downtimeEndAt ? new Date(a.downtimeEndAt).getTime() : null;
      return s !== null && n !== null && s <= e && e <= n;
    })) || null;
  }
  getNextActiveRelease() {
    var a;
    const e = Date.now(), t = (a = this.config.plannedReleases) == null ? void 0 : a.filter((s) => {
      const n = s.downtimeStartAt ? new Date(s.downtimeStartAt).getTime() : null, i = s.downtimeEndAt ? new Date(s.downtimeEndAt).getTime() : null;
      return n !== null && i !== null && n > e;
    }).sort((s, n) => {
      const i = new Date(s.downtimeStartAt).getTime(), c = new Date(n.downtimeStartAt).getTime();
      return i - c;
    });
    return (t == null ? void 0 : t[0]) || null;
  }
  getAllReleases() {
    return this.config.plannedReleases ?? [];
  }
  getCurrentVersion() {
    var e;
    return ((e = this.config) == null ? void 0 : e.version) ?? null;
  }
}
const _ = class _ {
  constructor(e) {
    this.flagDataCache = /* @__PURE__ */ new Map(), this.allFlagsLoaded = !1, this.segmentDataCache = /* @__PURE__ */ new Map(), this.allSegmentsLoaded = !1, this.ConditionsDataCache = /* @__PURE__ */ new Map(), this.allConditionsLoaded = !1, this.configDataCache = /* @__PURE__ */ new Map(), this.allConfigsLoaded = !1, this.flagDataArchivedCache = /* @__PURE__ */ new Map(), this.allArchivedFlagsLoaded = !1, this.createFeature = (t, a) => new J(a, {
      userContext: this.userContext,
      deviceContext: this.deviceContext,
      localFeatureContext: new A(t, a.__global_data === !0),
      segmentContext: { get: this.getSegmentGroup.bind(this) },
      featureContext: { get: this.getFeatureFlag.bind(this) },
      conditionContext: { get: this.getFeatureCondition.bind(this) }
    }), this.createSegmentGroup = (t, a) => new be(t, a), this.createFeatureConfig = (t, a) => new Ce(t, a), this.db = m.getInstance(e.firebase, e.workspace || "global"), this.userContext = e.userContext, this.deviceContext = A.getOrSetDeviceContext(e.environment || "development", e.workspace || "global");
  }
  async getFeatureFlag(e) {
    return this.safeFetch(h, e, this.createFeature.bind(this), this.flagDataCache);
  }
  async getFeatureFlagArchived(e) {
    return this.safeFetch(v, e, this.createFeature.bind(this), this.flagDataArchivedCache);
  }
  async getSegmentGroup(e) {
    return this.safeFetch(p, e, this.createSegmentGroup.bind(this), this.segmentDataCache);
  }
  async getFeatureCondition(e) {
    return this.safeFetch(b, e, (t, a) => a, this.ConditionsDataCache);
  }
  async getRemoteConfig(e) {
    return this.safeFetch(f, e, this.createFeatureConfig.bind(this), this.configDataCache);
  }
  async getFeatureFlags() {
    const e = await this.safeFetchAll(h, this.createFeature.bind(this), this.flagDataCache, this.allFlagsLoaded);
    return e && (A.cleanupStaleFeatures(Object.keys(e)), this.allFlagsLoaded = !0), e;
  }
  async getFeatureFlagsArchived({ useCache: e }) {
    const t = await this.safeFetchAll(v, this.createFeature.bind(this), this.flagDataArchivedCache, this.allArchivedFlagsLoaded, e);
    return t && (this.allFlagsLoaded = !0), t;
  }
  async getAllSegmentGroups() {
    const e = await this.safeFetchAll(p, this.createSegmentGroup.bind(this), this.segmentDataCache, this.allSegmentsLoaded);
    return e && (this.allSegmentsLoaded = !0), e;
  }
  async getAllFeatureConditions() {
    const e = await this.safeFetchAll(b, (t, a) => a, this.ConditionsDataCache, this.allConditionsLoaded);
    return e && (this.allConditionsLoaded = !0), e;
  }
  async getAllRemoteConfigs() {
    const e = await this.safeFetchAll(f, this.createFeatureConfig.bind(this), this.configDataCache, this.allConfigsLoaded);
    return e && (this.allSegmentsLoaded = !0), e;
  }
  subscribeToFeatureFlag(e, t, a) {
    return this.db.listenToDocWithFallback(
      h,
      e,
      (s) => {
        t(s ? this.createFeature(e, s) : null);
      },
      a
    );
  }
  subscribeToFeatureFlags(e, t) {
    return this.db.listenToCollectionWithFallback(
      h,
      (a) => {
        const s = {};
        Object.entries(a).forEach(([n, i]) => {
          s[n] = this.createFeature(n, i);
        }), A.cleanupStaleFeatures(Object.keys(s)), e(s);
      },
      t
    );
  }
  subscribeToRemoteConfig(e, t, a) {
    return this.db.listenToDocWithFallback(
      f,
      e,
      (s) => {
        t(s ? this.createFeatureConfig(e, s) : null);
      },
      a
    );
  }
  subscribeToAllRemoteConfigs(e, t) {
    return this.db.listenToCollectionWithFallback(
      f,
      (a) => {
        const s = {};
        Object.entries(a).forEach(([n, i]) => {
          s[n] = this.createFeatureConfig(n, i);
        }), e(s);
      },
      t
    );
  }
  subscribeToFeatureConditon(e, t, a) {
    return this.db.listenToDocWithFallback(
      b,
      e,
      (s) => {
        t(s || null);
      },
      a
    );
  }
  subscribeToAllFeatureConditons(e, t) {
    return this.db.listenToCollectionWithFallback(
      b,
      (a) => {
        const s = {};
        Object.entries(a).forEach(([n, i]) => {
          s[n] = i;
        }), e(s);
      },
      t
    );
  }
  subscribeToSegmentGroup(e, t, a) {
    return this.db.listenToDocWithFallback(
      p,
      e,
      (s) => {
        t(s ? this.createSegmentGroup(e, s) : null);
      },
      a
    );
  }
  subscribeToAllSegmentGroups(e, t) {
    return this.db.listenToCollectionWithFallback(
      p,
      (a) => {
        const s = {};
        Object.entries(a).forEach(([n, i]) => {
          s[n] = this.createSegmentGroup(n, i);
        }), e(s);
      },
      t
    );
  }
  // ----- Private Utilities -----
  async safeFetch(e, t, a, s) {
    try {
      if (!s.has(t)) {
        const n = await this.db.read(e, t);
        if (!n) return null;
        s.set(t, n);
      }
      return a(t, s.get(t));
    } catch (n) {
      return console.error(`Error fetching ${t} from ${e}:`, n), null;
    }
  }
  async safeFetchAll(e, t, a, s, n = !0) {
    if (n || a.clear(), n && s) {
      const i = {};
      for (const [c, l] of a.entries())
        i[c] = t(c, l);
      return i;
    }
    try {
      const i = await this.db.readAll(e);
      if (!i) return null;
      for (const [l, o] of Object.entries(i))
        a.set(l, o);
      const c = {};
      for (const [l, o] of a.entries())
        c[l] = t(l, o);
      return c;
    } catch (i) {
      return console.error(`Error loading data from ${e}:`, i), null;
    }
  }
};
_.Feature = J;
let X = _;
class De {
  constructor() {
  }
  static condition(e, t, a) {
    return { field: e, operator: t, value: a };
  }
  static allOf(...e) {
    return { allOf: e };
  }
  static anyOf(...e) {
    return { anyOf: e };
  }
  setCondition(e) {
    return this.condition = e, this;
  }
  build() {
    if (!this.condition) throw new Error("Condition must be defined.");
    return this.condition;
  }
}
class Fe {
  constructor(e) {
    this.type = e;
  }
  setRolloutConfig(e) {
    return this.config = e, this;
  }
  build() {
    return {
      type: this.type,
      config: this.config
    };
  }
}
const U = class U {
  constructor() {
    this.featureData = {
      enabled: !1,
      description: ""
    };
  }
  setFeatureName(e) {
    return this.featureName = e, this;
  }
  setDescription(e) {
    return this.featureData.description = e, this;
  }
  setEnabled(e) {
    return this.featureData.enabled = e, this;
  }
  setRolloutStrategy(e) {
    return this.featureData.rolloutStrategy || (this.featureData.rolloutStrategy = {}), this.featureData.rolloutStrategy = e, this;
  }
  setCondition(e) {
    return this.featureData.condition = e, this;
  }
  setReleaseDate(e) {
    return this.featureData.releaseDate = new Date(e).toISOString(), this;
  }
  build() {
    return this.featureData;
  }
};
U.RolloutStrategy = Fe;
let k = U;
var u = /* @__PURE__ */ ((r) => (r[r.CREATE = 0] = "CREATE", r[r.UPDATE = 1] = "UPDATE", r[r.DELETE = 2] = "DELETE", r[r.MOVE = 3] = "MOVE", r[r.COPY = 4] = "COPY", r[r.ARCHIVE = 5] = "ARCHIVE", r[r.UNARCHIVE = 6] = "UNARCHIVE", r))(u || {});
function S(r) {
  if (!/^[a-z0-9]+(_[a-z0-9]+)*$/.test(r))
    throw new Error(`Invalid flagName "${r}". Must be in snake_case.`);
}
const W = class W {
  constructor(e) {
    this.suppressLogging = !1, this.database = m.getInstance(e.firebase, e.workspace || "global"), this.getAuthUser = e.getAuthUser;
  }
  static preserveUpdates(e, t) {
    const a = { ...t };
    return e.createdAt && (a.createdAt = e.createdAt), a;
  }
  async generateLog(e, t, a, s, n) {
    if (this.suppressLogging) return;
    const i = this.database.createCollectionReference(t, this.database.workspace, ee), c = {
      timestamp: (/* @__PURE__ */ new Date()).toISOString(),
      user: this.getAuthUser(),
      entity: e,
      action: a,
      message: s
    };
    n && (c.value = JSON.stringify(n)), await this.database.addDocToCollection(i, c);
  }
  async runWithoutLogging(e) {
    this.suppressLogging = !0;
    try {
      return await e();
    } finally {
      this.suppressLogging = !1;
    }
  }
  async setFeatureFlag(e, t = {}) {
    S(e), await this.database.create(h, e, t), this.generateLog(e, h, u.CREATE, `Feature Flag ${e} created`, t);
  }
  async updateFeatureFlag(e, t = {}) {
    await this.database.update(h, e, t), this.generateLog(e, h, u.UPDATE, `Feature Flag ${e} updated`, t);
  }
  async deleteFeatureFlag(e) {
    await this.database.delete(h, e), this.generateLog(e, h, u.DELETE, `Feature Flag ${e} deleted`);
  }
  async registerFeatureCondition(e, t) {
    S(e), await this.database.create(b, e, t), this.generateLog(e, b, u.CREATE, `Condition ${e} created`, t);
  }
  async updateFeatureCondition(e, t) {
    await this.database.update(b, e, t), this.generateLog(e, b, u.UPDATE, `Condition ${e} updated`, t);
  }
  async deleteFeatureCondition(e) {
    await this.database.delete(b, e), this.generateLog(e, b, u.DELETE, `Condition ${e} deleted`);
  }
  async registerSegmentGroup(e, t, a) {
    S(e), await this.database.create(p, e, {
      type: t,
      criteria: a
    }), this.generateLog(e, p, u.CREATE, `Segment ${e} created`, { segmentType: t, segmentCriteria: a });
  }
  async updateSegmentGroup(e, t, a) {
    await this.database.update(p, e, {
      type: t,
      criteria: a
    }), this.generateLog(e, p, u.UPDATE, `Segment ${e} updated`, { segmentType: t, segmentCriteria: a });
  }
  async deleteSegmentGroup(e) {
    await this.database.delete(p, e), this.generateLog(e, p, u.DELETE, `Segment ${e} deleted`);
  }
  async registerFeatureConfig(e, t) {
    S(e), await this.database.create(f, e, t), this.generateLog(e, f, u.CREATE, `Feature config ${e} created`, t);
  }
  async updateFeatureConfig(e, t) {
    await this.database.update(f, e, t), this.generateLog(e, f, u.UPDATE, `Feature config ${e} updated`, t);
  }
  async deleteFeatureConfig(e) {
    await this.database.delete(f, e), this.generateLog(e, f, u.DELETE, `Feature config ${e} deleted`);
  }
  async archiveFeatureFlag(e, t) {
    return t ? (await this.runWithoutLogging(async () => {
      await this.deleteFeatureFlag(e);
    }), await this.database.create(v, e, t), this.generateLog(e, h, u.ARCHIVE, `Feature Flag ${e} archived`, t), !0) : !1;
  }
  async unarchiveFeatureFlag(e, t) {
    return t ? (await this.runWithoutLogging(async () => {
      await this.setFeatureFlag(e, t);
    }), await this.database.delete(v, e), this.generateLog(e, h, u.UNARCHIVE, `Feature Flag ${e} unarchived`, t), !0) : !1;
  }
  async deleteArchivedFeatureFlag(e) {
    await this.database.delete(v, e), this.generateLog(e, h, u.DELETE, `Archived Feature Flag ${e} deleted`);
  }
  async moveFeatureToWorkspace(e, t, a) {
    if (!t) return !1;
    await this.runWithoutLogging(async () => {
      await this.copyFeatureToWorkspace(e, t, a), await this.deleteFeatureFlag(e);
    }), this.generateLog(e, h, u.MOVE, `Feature Flag ${e} moved to workspace ${a}`, t);
  }
  async copyFeatureToWorkspace(e, t, a) {
    if (!t) return !1;
    const s = this.database.createDocReference(e, h, a);
    await this.database.createWithRef(s, t), await this.generateLog(e, h, u.COPY, `Feature Flag ${e} copied to workspace ${a}`, t);
  }
};
W.FeatureBuilder = k;
let Z = W;
class ve {
  constructor(e, t = "global") {
    this.workspace = t, this.db = m.getInstance(e, t);
  }
  async getLogsForEntity(e, t) {
    const a = [
      H("timestamp", "desc")
    ];
    return (await this.fetchLogs(e, a)).filter((n) => n.entity === t);
  }
  async getAllLogs(e) {
    const t = [H("timestamp", "desc")], a = await this.fetchLogsWithId(e, t), s = {};
    return a.forEach(({ id: n, log: i }) => {
      s[n] = i;
    }), s;
  }
  async fetchLogs(e, t) {
    const a = await this.queryLogs(e, t), s = [];
    return a.forEach((n) => {
      const i = n.data();
      this.isValidLog(i) && s.push(i);
    }), s;
  }
  async fetchLogsWithId(e, t) {
    const a = await this.queryLogs(e, t), s = [];
    return a.forEach((n) => {
      const i = n.data();
      this.isValidLog(i) && s.push({ id: n.id, log: i });
    }), s;
  }
  async queryLogs(e, t) {
    const a = this.db.createCollectionReference(
      e,
      this.workspace,
      ee
    ), s = re(a, ...t);
    return await $(s);
  }
  isValidLog(e) {
    return e && typeof e.timestamp == "string" && typeof e.entity == "string" && typeof e.action == "number" && typeof e.message == "string";
  }
}
export {
  De as ConditionBuilder,
  k as FeatureBuilder,
  X as FeatureReader,
  Z as FeatureWriter,
  ve as LogReader,
  Fe as RolloutStrategyBuilder
};
